module.exports = __webpack_public_path__ + "static/img/miyu.cd834ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/miyu.png
// module id = 4gqi
// module chunks = 24